import type { ScheduleTreeItem } from "@/adapters/api";
import { daysUntil } from "./format.ts";

export interface Milestone {
	stageId: string;
	name: string;
	plannedEndDate: string;
	days: number;
}

export function nextMilestone(
	items: ScheduleTreeItem[],
	reference: string,
): Milestone | null {
	let next: Milestone | null = null;

	for (const item of items) {
		if (item.status === "completed" || item.status === "cancelled") continue;

		const plannedEndDate = item.own_planned_end_date ?? item.planned_end_date;
		if (!plannedEndDate) continue;

		const days = daysUntil(plannedEndDate, reference);
		if (days === null || days < 0) continue;

		if (!next || plannedEndDate < next.plannedEndDate) {
			next = { stageId: item.stage_id, name: item.name, plannedEndDate, days };
		}
	}

	return next;
}
